module.exports = __webpack_public_path__ + "img/lookbook_16_center.e606f14d.png";